var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-right" },
    [
      _c(
        "b-button",
        {
          staticClass: "btn-icon rounded-circle mt-1",
          attrs: { size: "sm", id: "popover-private", variant: "flat-primary" }
        },
        [_c("feather-icon", { attrs: { icon: "InfoIcon" } })],
        1
      ),
      _c(
        "b-popover",
        {
          attrs: {
            target: "popover-private",
            triggers: "focus",
            placement: "top"
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function() {
                return [_c("span", [_vm._v("Flujo Privado!")])]
              },
              proxy: true
            }
          ])
        },
        [
          _c("span", [
            _vm._v(" Si seleccionas que el flujo sea privado, "),
            _c("b", [_vm._v("sólo tú y las personas que formen parte de él")]),
            _vm._v(" podrán ver su información ")
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }